var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.model && _vm.model.middleEar
    ? _c("div", [
        _c(
          "div",
          {
            staticClass: "page middleEar-page",
            staticStyle: { margin: "0 auto", border: "0px solid #E8E8EC" },
            attrs: { id: "print_middleEar" },
          },
          [
            _c("div", { staticStyle: { height: "50px" } }),
            _c("div", { staticStyle: { "font-size": "18px" } }, [
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.model.middleEar.hospitalName
                      ? _vm.model.hospitalName
                      : ""
                  )
                ),
              ]),
            ]),
            _c(
              "div",
              {
                staticStyle: {
                  "font-size": "22px",
                  padding: "20px 0 30px 0",
                  "font-weight": "600",
                },
              },
              [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.model.middleEar.reportName
                        ? _vm.model.middleEar.reportName
                        : "中耳筛查报告"
                    )
                  ),
                ]),
              ]
            ),
            _c(
              "table",
              {
                staticStyle: {
                  "margin-top": "15px",
                  "text-align": "left",
                  width: "100%",
                  "border-collapse": "collapse",
                  border: "none",
                  "border-bottom": "1px solid #0E0E0EFF",
                },
              },
              [
                _c("tbody", [
                  _c(
                    "tr",
                    {
                      staticStyle: {
                        "line-height": "35px",
                        width: "100%",
                        "border-collapse": "collapse",
                        "text-align": "left",
                        border: "none",
                      },
                    },
                    [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._v("姓名："),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.middleEar.name
                                  ? _vm.model.middleEar.name
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._v("性别："),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.middleEar.sex
                                  ? _vm.model.middleEar.sex
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._v("年龄："),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.middleEar.age
                                  ? _vm.model.middleEar.age
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]
            ),
            _c(
              "table",
              {
                staticStyle: {
                  "margin-top": "10px",
                  width: "100%",
                  "border-collapse": "collapse",
                  border: "none",
                },
              },
              [
                _c("tbody", [
                  _c(
                    "tr",
                    { staticStyle: { "text-align": "left", border: "none" } },
                    [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._m(0),
                          _c("div", { staticStyle: { "min-height": "50px" } }, [
                            _c("p", [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.model.middleEar.result
                                      ? _vm.model.middleEar.result
                                      : ""
                                  )
                                ),
                              ]),
                            ]),
                          ]),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "tr",
                    { staticStyle: { "text-align": "left", border: "none" } },
                    [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._m(1),
                          _c("div", { staticStyle: { "min-height": "50px" } }, [
                            _c("p", [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.model.middleEar.proposal
                                      ? _vm.model.middleEar.proposal
                                      : ""
                                  )
                                ),
                              ]),
                            ]),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]
            ),
            _c(
              "table",
              {
                staticStyle: {
                  "margin-top": "30px",
                  "text-align": "left",
                  width: "100%",
                  "border-collapse": "collapse",
                  border: "none",
                  "border-top": "1px solid #0E0E0EFF",
                },
              },
              [
                _c("tbody", [
                  _c(
                    "tr",
                    {
                      staticStyle: {
                        width: "100%",
                        "border-collapse": "collapse",
                        "text-align": "left",
                        border: "none",
                        "line-height": "30px",
                      },
                    },
                    [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "80%",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._v("医生："),
                          _vm.model.middleEar.doctorSignature
                            ? _c("img", {
                                staticStyle: {
                                  height: "40px",
                                  width: "100px",
                                  "object-fit": "contain",
                                },
                                attrs: {
                                  src: _vm.model.middleEar.doctorSignature,
                                },
                              })
                            : _vm._e(),
                        ]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._v("日期："),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.middleEar.screeningDate
                                  ? _vm.model.middleEar.screeningDate
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]
            ),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("p", { staticStyle: { "font-size": "23px", "font-weight": "bold" } }, [
        _vm._v("结果"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("p", { staticStyle: { "font-size": "23px", "font-weight": "bold" } }, [
        _vm._v("建议"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }